import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { licenseService } from '../services/api/licenseService'

const LICENSE_QUERY_KEY = ['license']

export const useLicense = () => {
  const queryClient = useQueryClient()

  const licenseQuery = useQuery({
    queryKey: LICENSE_QUERY_KEY,
    queryFn: () => licenseService.get(),
  })

  const regenerateMutation = useMutation({
    mutationFn: () => licenseService.regenerate(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LICENSE_QUERY_KEY })
    },
  })

  const removeActivationMutation = useMutation({
    mutationFn: (activationId) => licenseService.removeActivation(activationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: LICENSE_QUERY_KEY })
    },
  })

  return {
    license: licenseQuery.data,
    isLoading: licenseQuery.isLoading,
    error: licenseQuery.error,
    refetch: licenseQuery.refetch,

    regenerate: regenerateMutation.mutateAsync,
    isRegenerating: regenerateMutation.isPending,

    removeActivation: removeActivationMutation.mutateAsync,
    isRemovingActivation: removeActivationMutation.isPending,
  }
}
